/**
 * CAPTCHA configuration (Google reCAPTCHA v2 checkbox).
 *
 * Kill switch: REACT_APP_ENABLE_CAPTCHA=true to show captcha on login/register.
 * When off (default), no widget and no captcha check (email/password only).
 *
 * When enabled:
 *   - Set REACT_APP_RECAPTCHA_SITE_KEY (Vercel + redeploy).
 *   - https://www.google.com/recaptcha/admin — v2 checkbox.
 *
 * https://www.google.com/recaptcha/admin
 */

const enabled = process.env.REACT_APP_ENABLE_CAPTCHA === 'true';
const fromEnv = process.env.REACT_APP_RECAPTCHA_SITE_KEY?.trim() || '';
const isDevelopment = process.env.NODE_ENV === 'development';

const siteKey = enabled ? fromEnv : '';

export const CAPTCHA_CONFIG = {
  ENABLED: enabled,
  SITE_KEY: siteKey,
  IS_CONFIGURED: enabled && Boolean(siteKey),
  /** No captcha UI or submit check. */
  SKIP_UI: !enabled || (isDevelopment && !fromEnv),
  THEME: 'light',
  SIZE: 'normal',
};

export const isProduction = process.env.NODE_ENV === 'production';
